import { useEffect, useRef } from "react";

import { usePipOptional } from "./PipContext";

export default function PipAnchor({ id, children, className = "", style = {} }) {
  const ref = useRef(null);
  const pip = usePipOptional();
  const registerAnchor = pip?.registerAnchor;
  const unregisterAnchor = pip?.unregisterAnchor;

  useEffect(() => {
    if (!registerAnchor || !unregisterAnchor || !id) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    const update = () => {
      const rect = el.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        registerAnchor(id, rect);
      }
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    window.addEventListener("scroll", update, true);
    window.addEventListener("resize", update);

    return () => {
      unregisterAnchor(id);
      ro.disconnect();
      window.removeEventListener("scroll", update, true);
      window.removeEventListener("resize", update);
    };
  }, [registerAnchor, unregisterAnchor, id]);

  return (
    <span ref={ref} className={className} style={{ position: "relative", ...style }} data-pip-anchor={id}>
      {children}
    </span>
  );
}
